import { Input, RadioGroup, Selector } from 'components/common';
import React from 'react';
import { Control, FieldPath, FieldValues } from 'react-hook-form';
import { GENDER_RADIO_VALUES, HUMAN_RACES } from '../constants';
import { AuthError } from 'types/enums';
import { Box } from '@mui/material';

type Properties<T extends FieldValues> = {
  control: Control<T, null>;
  fieldNames: {
    dateOfBirth: FieldPath<T>;
    medicalRecordNumber: FieldPath<T>;
    race: FieldPath<T>;
    gender: FieldPath<T>;
    conditions: FieldPath<T>;
  };
};

export const PatientForm = <T extends FieldValues>({ control, fieldNames }: Properties<T>) => {
  const { dateOfBirth, medicalRecordNumber, race, gender } = fieldNames;

  return (
    <Box sx={{ width: '100%' }} data-testid='ps-sign-up-patient-form-test-id'>
      <h2>Patient Data</h2>
      <Input
        rules={{ required: { value: true, message: AuthError.DATE_OF_BIRTH_REQUIRED } }}
        label='Birth Date'
        placeholder='Enter birth date'
        control={control}
        type='date'
        name={dateOfBirth}
        fullWidth
      />
      <Input
        rules={{ required: { value: true, message: AuthError.MEDICAL_RECORD_REQUIRED } }}
        label='Medical Record Number'
        placeholder='Enter medical record number'
        control={control}
        name={medicalRecordNumber}
        fullWidth
      />
      <Selector label='Choose your race' control={control} name={race} values={HUMAN_RACES} />
      <RadioGroup label='Gender' name={gender} control={control} values={GENDER_RADIO_VALUES} />
      {/* <MultiSelector
        label='Choose your conditions'
        control={control}
        name={conditions}
        values={PATIENT_CONDITIONALS}
        placeholder='Search your conditions'
      /> */}
    </Box>
  );
};
